import axios from "axios";

import { Client, IClient } from "@/shared/model/client.model";
import { IClientProfiles } from "../model/global/dashboard/client-profiles.model";
import { ReportDashboard } from "../model/global/dashboard/report-dashboard.model";

const baseApiUrl = "api/clients";
export default class ClientService {
  public getProfiles(id: number): Promise<IClientProfiles> {
    return new Promise<IClientProfiles>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-profiles/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getReports(id: number): Promise<ReportDashboard[]> {
    return new Promise<ReportDashboard[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}/reports`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(client: Client): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/create`, client)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findById(id: number): Promise<IClient> {
    return new Promise<IClient>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/` + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public removeClientFromDashboard(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/remove-client-from-dashboard/${id}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public setConfidentiality(bool: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/confidential/` + bool)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public edit(client): Promise<IClient> {
    return new Promise<IClient>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/edit`, client)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public checkPhoneNumber(client): Promise<IClient> {
    return new Promise<IClient>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/check-phone-number/${client.id}/${client.phoneNb}`)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public saveAllClientUpdated(listClient): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-multiple-client`,listClient)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
